import * as Yup from 'yup';

const ManualInteractiveTimeSchema = () =>
  Yup.object().shape({
    time: Yup.number().min(0).max(60).required(),
    comment: Yup.string().required(),
  });

export const manualEnterCallSchema = () =>
  Yup.object().shape({
    phoneNumber: Yup.string()
      .matches(/^[+][0-9]*$/, 'Phone number is not correct')
      .required('required'),
  });

export default ManualInteractiveTimeSchema;
